import {Providers} from "../../enums/providers";

export class LogOnInternalRs {

    constructor(error:string="")
    {
        this.Error = error;   
    }

    Error:string="";    
    ProviderAccounts:ProviderAccount[] = [];
    ProviderInstruments:ProviderInstrument[] = [];

}


export class ProviderAccount
{
     Provider:Providers = Providers.DEMO;
     AccountName:string = "";
     AccountID:string = "";
     Balance:number =0;
     Currency:string = "";
     PnL:number = 0;
    
}

export class ProviderInstrument
{
    Symbol:string = "";
    MarginPercentage:number=0;
}

